import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { ccLogo } from "../../assets/data/Assests";
import { setAuthData } from "../../redux/ApiSlice/Auth/AuthSlice";
import { AccountProfile } from "../../redux/ApiSlice/AccountProfileSlice";
import { setClearHomepageVideos } from "../../redux/ApiSlice/HomePageVideoSlice";

// Backend redirects here on Apple OAuth success:
// /auth/apple/callback?access=TOKEN&refresh=TOKEN&session_key=SK&browser_group_id=BG&is_new=bool&is_profile_completed=bool

export default function AppleCallback() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const access = params.get("access");
        const refresh = params.get("refresh");
        const session_key = params.get("session_key");
        const browser_group_id = params.get("browser_group_id");
        const isNew = params.get("is_new") === "true";
        const isProfileCompleted = params.get("is_profile_completed") !== "false";

        if (!access || !refresh) {
            setErrorMsg("Sign in with Apple failed. Please try again.");
            return;
        }

        const finish = async () => {
            try {
                dispatch(setClearHomepageVideos());
                dispatch(setAuthData({ access, refresh, session_key, browser_group_id }));
                if (isNew) localStorage.setItem("new_User", "true");
                await dispatch(AccountProfile());
                toast.success("Successfully signed in with Apple!");

                if (isNew || !isProfileCompleted) {
                    sessionStorage.setItem("show_interests", "true");
                    navigate("/user-intrest", { replace: true });
                } else {
                    navigate("/", { replace: true });
                }
            } catch {
                setErrorMsg("Something went wrong after sign in. Please try again.");
            }
        };

        finish();
    }, [dispatch, navigate]);

    if (errorMsg) {
        return (
            <div className="h-full w-full flex flex-col items-center justify-center bg-white dark:bg-[#1E1D21] px-6">
                <img alt="logo" src={ccLogo} className="h-16 w-16 mb-6" />
                <p className="text-[16px] font-bold text-red-500 mb-2 text-center">Sign in Failed</p>
                <p className="text-[13px] text-gray-600 dark:text-gray-300 text-center mb-6">{errorMsg}</p>
                <button
                    onClick={() => navigate("/login", { replace: true })}
                    className="w-full max-w-xs h-12 rounded-xl bg-[#BDE6FF] text-gray-900 font-semibold text-[14px]"
                >
                    Back to Login
                </button>
            </div>
        );
    }

    return (
        <div className="h-full w-full flex flex-col items-center justify-center bg-white dark:bg-[#1E1D21]">
            <img alt="logo" src={ccLogo} className="h-16 w-16 mb-4 animate-pulse" />
            <p className="text-[14px] font-medium text-gray-600 dark:text-gray-300">Signing you in with Apple...</p>
        </div>
    );
}
